<!--/*
* @name: 时间选择组件
* @description: 
* @author: zefeng(zefeng.chen@shengyc.com)
* @Date: 2019-08-20 14:41:41
* @LastEditTime: 2019-08-20 14:41:41
*/-->

<template>
    <div class="time-container">
        <!-- <div class="time-item-container">
      <el-date-picker
        size="mini"
        prefix-icon="a"
        v-model="childStartTime"
        class="h100 black opacity opacity-date flex"
        :clearable="false"
        value-format="timestamp"
        :editable="false"
        popper-class="black"
        type="datetime"
        @change="$_reqData"
      ></el-date-picker>
    </div>
    <span>-</span>
    <div class="time-item-container">
      <el-date-picker
        size="mini"
        prefix-icon="a"
        v-model="childEndTime"
        class="h100 black opacity opacity-date flex"
        :clearable="false"
        value-format="timestamp"
        :editable="false"
        popper-class="black"
        type="datetime"
        @change="$_reqData"
      ></el-date-picker>
    </div> -->
        <el-date-picker
            v-model="times"
            size="mini"
            type="datetimerange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            :clearable="false"
            @change="changeTime"
            value-format="timestamp"
            :default-time="['00:00:00', '23:59:59']"
        ></el-date-picker>
    </div>
</template>

<script>
import { Toast, Loading } from 'vant'
export default {
    props: {
        start_time: {
            type: Number,
            default: Date.now() - 8.64e7,
        },
        end_time: {
            type: Number,
            default: Date.now(),
        },
        comDataList: {
            type: [Array],
        },
    },
    mounted() {
        this.$_reqData()
    },
    data() {
        return {
            childStartTime: this.start_time,
            childEndTime: this.end_time,
            times: [this.start_time, this.end_time],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一天',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1)
                            picker.$emit('pick', [start, end])
                        },
                    },
                    {
                        text: '最近三天',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 3)
                            picker.$emit('pick', [start, end])
                        },
                    },
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                            picker.$emit('pick', [start, end])
                        },
                    },
                ],
            },
        }
    },
    methods: {
        $_reqData() {
            let start_time = this.times[0]
            let end_time = this.times[1]
            if (start_time > Date.now()) {
                Toast('开始时间不能大于当前时间！')
                return
            }
            if (end_time > Date.now()) {
                Toast('结束时间不能大于当前时间！')
                return
            }
            if (start_time > end_time) {
                Toast('结束时间不能小于开始时间！')
                return
            }
            this.$emit('change', {
                start_time,
                end_time,
            })
        },
        changeTime() {
            this.$_reqData()
        },
    },
    watch: {
        comDataList: {
            handler() {
                this.$_reqData()
            },
            deep: true,
        },
    },
}
</script>

<style lang="scss" scoped>
@import '../../assets/style/mixin';
%h-100 {
    height: 100%;
}
%flex {
    display: flex;
    align-items: center;
}
%c-fff {
    color: #fff;
}
%box {
    box-sizing: border-box;
}
.time-container {
    @extend %h-100;
    @extend %flex;
    > span {
        // @extend %c-fff;
        margin: 0 10px;
        font-size: 14px;
    }
}
.time-item-container {
    // @extend %h-100;
    @extend %box;
    border-bottom: 1px solid #666;
    .el-input {
        width: vw(125);
        @extend %h-100;
    }
}
</style>
